import { render, staticRenderFns } from "./DatabaseConnectionConfiguration.vue?vue&type=template&id=33c8c5d0&scoped=true&"
import script from "./DatabaseConnectionConfiguration.vue?vue&type=script&lang=js&"
export * from "./DatabaseConnectionConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseConnectionConfiguration.vue?vue&type=style&index=0&id=33c8c5d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c8c5d0",
  null
  
)

export default component.exports